<template>
  <div
    :class="[
      newItem ? 'background-color-green' : 'background-color-fire-engine-red',
      'color-white',
      'corner-ribbon',
      'font-weight-semibold',
      classes,
    ]"
  >
    {{ newItem ? "NEW" : "DEAL" }}
  </div>
</template>

<script>
const classes = {
  large: "large",
  small: "small font-size-xs",
};

export default {
  name: "CornerRibbon",
  data() {
    return {
      classes: this.large ? classes.large : classes.small,
    };
  },
  props: { large: Boolean, newItem: Boolean },
};
</script>

<style scoped>
.corner-ribbon {
  position: absolute;
  text-align: center;
  transform: rotate(45deg);
}

.large {
  line-height: 24px;
  right: -28px;
  top: 18px;
  width: 115px;
}

.small {
  line-height: 16px;
  right: -20px;
  top: 10px;
  width: 80px;
}
</style>
